export default {
  getActiveMenu: state => {
    let result = null
    const arr = state.menu.children
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].isActive) {
        result = i
        break
      }
    }
    return result
  }
}
